import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {ProjectCareSubRegimeFields} from '@/features/projects/components/project-form/project-care-fields/ProjectCareSubRegimeFields'
import {ProjectRehabCareCommitmentData} from '@/features/projects/components/project-form/project-care-fields/ProjectRehabCareCommitmentData'
import {ProjectCycleCountField} from '@/features/projects/components/project-form/project-cycle-count-field/ProjectCycleCountField'
import {ProjectExpirationDateFields} from '@/features/projects/components/project-form/project-expiration-date-fields/ProjectExpirationDateFields'
import {ProjectSectorField} from '@/features/projects/components/project-form/project-sector-field/ProjectSectorField'
import {ProjectStartDateField} from '@/features/projects/components/project-form/project-start-date-field/ProjectStartDateField'
import {ProjectTypeFields} from '@/features/projects/components/project-form/project-type-fields/ProjectTypeFields'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectFormDetailsSectionSchema = ProjectFieldsSchema.pick({
    projectType: true
})
type ProjectFormDetailsSectionSchemaType = z.infer<typeof ProjectFormDetailsSectionSchema>

export const ProjectFormDetailsSection = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectFormDetailsSectionSchemaType>()
    const projectType = useWatch({control, name: 'projectType'})

    return (
        <FormSection title={t('projects:project_details')} hasBottomDivider>
            <Flexbox direction="column" gap={4} fullWidth>
                <Grid columns={3} gap={4} fullWidth>
                    <GridItem spanColumn={2}>
                        <ProjectTypeFields />
                    </GridItem>
                    {projectType == 'cyclic' && (
                        <GridItem spanColumn={1} fullWidth>
                            <ProjectCycleCountField />
                        </GridItem>
                    )}
                </Grid>

                <ProjectSectorField />

                <Grid columns={3} gap={4} fullWidth>
                    <ProjectCareSubRegimeFields />
                    <ProjectRehabCareCommitmentData />
                </Grid>

                <Grid columns={3} gap={4} fullWidth>
                    <ProjectStartDateField />
                </Grid>

                <ProjectExpirationDateFields />

                <Flexbox direction="column" gap={1.5}>
                    <Text palette="neutral" shade="500" size="textSm" weight="500">
                        {t('commons:welfare_system')}
                    </Text>
                    <Text size="textSm" weight="500">
                        {t('projects:non_residential')}
                    </Text>
                </Flexbox>
            </Flexbox>
        </FormSection>
    )
}
